/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const starHalf = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M10 1L7 7l-6 .75 4.13 4.62L4 19l6-3 6 3-1.12-6.63L19 7.75 13 7zm0 2.24l2.34 4.69 4.65.58-3.18 3.56.87 5.15L10 14.88V3.24z" />
	</SVG>
);

export default starHalf;
